// extracted by mini-css-extract-plugin
export default {"root":"Comments_root__UozaY","comment":"Comments_comment__lO3dx","childComment":"Comments_childComment__BrmKH"};